import { EPaymentStatus } from '../../common/types';

export enum EGiftCardTheme {
  LAVANDE = 'lavande',
  ETRETAT = 'etretat',
  CHAMBORD = 'chambord',
  MONT_SAINT_MICHEL = 'mont-saint-michel',
  ESTEREL = 'esterel',
  COLMAR = 'colmar',
  VERDON = 'verdon',
  PARIS = 'paris',
  AMSTERDAM = 'amsterdam',
  KINDERDIJK = 'kinderdijk',
  BIG_BEN = 'big-ben',
  TOWER_BRIDGE = 'tower-bridge',
}

export enum EGiftCardFormat {
  ECARD = 'ECARD',
  PRINT = 'PRINT',
}

export interface ICreateGiftCardPurchasePayload {
  theme: EGiftCardTheme;
  format: EGiftCardFormat;
  amountCents: number;
  fromName: string;
  toName: string;
  message?: string;
  buyerEmail: string;
  recipientEmail?: string;
  /** FORMAT: ISO 8601. None: sent once paid */
  sendAt?: string;
  /** The travellers offer of an order email: 5 % off */
  offerToken?: string;
}

export interface ICreateGiftCardPurchaseResponse {
  purchaseId: string;
  paylineToken: string;
  /** What the buyer pays */
  priceCents: number;
}

export interface IGiftCardPurchaseStatus {
  id: string;
  paymentStatus: EPaymentStatus;
  format: EGiftCardFormat;
  amountCents: number;
  recipientEmail: string | null;
  sendAt: string | null;
  toName: string;
  /** The e-card already left: its date and recipient can no longer change */
  isSent: boolean;
}

export interface IChangeGiftCardDeliveryPayload {
  /** The token of the link in the receipt */
  token: string;
  recipientEmail: string;
  /** Null: at once. FORMAT: ISO 8601 */
  sendAt: string | null;
}

export interface IGiftCardBalance {
  code: string;
  theme: string;
  fromName: string;
  initialCents: number;
  balanceCents: number;
  expiresAt: string;
  isUsable: boolean;
}

export enum EPromoCodeRefusal {
  UNKNOWN = 'UNKNOWN',
  DISABLED = 'DISABLED',
  NOT_STARTED = 'NOT_STARTED',
  EXPIRED = 'EXPIRED',
  WRONG_BRAND = 'WRONG_BRAND',
  EMAIL_NOT_ALLOWED = 'EMAIL_NOT_ALLOWED',
  EMAIL_MISSING = 'EMAIL_MISSING',
  FIRST_ORDER_ONLY = 'FIRST_ORDER_ONLY',
  GLOBAL_LIMIT_REACHED = 'GLOBAL_LIMIT_REACHED',
  CUSTOMER_LIMIT_REACHED = 'CUSTOMER_LIMIT_REACHED',
  BUDGET_SPENT = 'BUDGET_SPENT',
  NO_BALANCE = 'NO_BALANCE',
  MIN_ORDER_NOT_REACHED = 'MIN_ORDER_NOT_REACHED',
  CARRIER_EXCLUDED = 'CARRIER_EXCLUDED',
  MODE_EXCLUDED = 'MODE_EXCLUDED',
  TRAVEL_DATE_EXCLUDED = 'TRAVEL_DATE_EXCLUDED',
  ONE_PROMO_ONLY = 'ONE_PROMO_ONLY',
  NOT_STACKABLE = 'NOT_STACKABLE',
  ALREADY_APPLIED = 'ALREADY_APPLIED',
  NOTHING_TO_PAY = 'NOTHING_TO_PAY',
  ANCILLARY_MISSING = 'ANCILLARY_MISSING',
  /** A code kept for some emails: the customer types the 6 digits sent to the email of the order first */
  EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
  OWN_OFFER_CARD = 'OWN_OFFER_CARD',
}

export enum EEmailCheckResult {
  VERIFIED = 'VERIFIED',
  WRONG_CODE = 'WRONG_CODE',
  /** Expired or too many wrong codes: a new code must be sent */
  NO_CODE = 'NO_CODE',
}

export interface IAppliedPromoCode {
  code: string;
  amountCents: number;
  refusal: EPromoCodeRefusal | null;
  /** Gift cards: what stays on the card after this order */
  balanceAfterCents?: number;
}

export interface ISetPromoCodesResponse {
  applied: IAppliedPromoCode[];
  totalCents: number;
  /** A 6 digit code left for the email of the cart (once a minute at most) */
  isEmailCheckSent?: boolean;
}

export interface IPublicPromoCode {
  code: string;
  bannerText: string;
}

export interface IReferral {
  code: string;
  link: string;
}

export interface IReferralInvite {
  code: string;
  firstName: string;
  amountCents: number;
}

export interface IGiftCardOffer {
  percent: number;
  /** FORMAT: YYYY-MM-DD */
  travelFrom: string;
  /** FORMAT: ISO 8601 */
  expiresAt: string;
}
